<template>
  <div>
    <div class="card">
        <div class="card-body">
            <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Management <small class="text-muted">shipment</small>
                  </h4>
              </div><!--col-->
              <div class="col-sm-7">
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                  <router-link :to="{ path: '/delivery/shipment/upload' }" class="btn btn-primary ml-1" data-toggle="tooltip" title="Upload Shipments">
                    <i class="fa fa-upload"></i>
                  </router-link>
                </div>
              </div><!--col-->
            </div><!--row-->
            <hr />
            <div class="row mt-4">
              <div class="col-sm-6">
                <h5 class="mb-3">{{ $t('delivery.shipment.filter_option') }}</h5>
                <b-form v-if="show">
                  <div class="form-group row">
                    <label for="" class="col-sm-3 col-form-label">{{ $t('delivery.shipment.shipment_date') }}</label>
                    <div class="col-sm-9 row">
                      <div class="col-sm-6 form-row">
                          <datepicker v-model="filter.uploadDateFrom" :format="customFormatter" input-class="form-control"></datepicker>
                        </div>
                        <div class="col-sm-6 form-row">
                          <datepicker v-model="filter.uploadDateTo" :format="customFormatter" input-class="form-control"></datepicker>
                        </div>
                    </div>
                  </div>
                  <b-form-fieldset
                    :label="$t('delivery.shipment.courier')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-select v-model="filter.courierId" :options="courierOptions" class="mb-1" />
                  </b-form-fieldset>
                  <b-form-fieldset
                    :label="$t('delivery.shipment.reference_no')"
                    :description="$t('delivery.shipment.please_enter_reference_no')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="text" v-model="filter.referenceNo" :placeholder="$t('delivery.shipment.enter_reference_no')"></b-form-input>
                  </b-form-fieldset>
                  <b-form-fieldset
                    :label="$t('delivery.shipment.tracking_no')"
                    :description="$t('delivery.shipment.please_enter_tracking_no')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="text" v-model="filter.trackingNo" :placeholder="$t('delivery.shipment.enter_tracking_no')"></b-form-input>
                  </b-form-fieldset>
                  <b-form-fieldset
                    :label="$t('delivery.shipment.status')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-select v-model="filter.status" :options="statusOptions" class="mb-3" />
                  </b-form-fieldset>
                  <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('delivery.shipment.search') }}</b-button>
                  <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('delivery.shipment.reset') }}</b-button>
                  <b-button size="sm" variant="success ml-1" @click="downloadFilterShipments()"><i class="fa fa-download"></i>&nbsp; {{ $t('delivery.label.download_below_order') }}</b-button>
                  <b-button size="sm" variant="warning ml-1" @click="downloadNotDeliveriedShipments()"><i class="fa fa-download"></i>&nbsp; {{ $t('delivery.label.download_not_delivered_order') }}</b-button>
                </b-form>
              </div><!--col-->
            </div>
            <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                    <table class="table">
                      <colgroup>
                        <col width="3%">
                        <col width="8%">
                        <col width="8%">
                        <col width="8%">
                        <col width="8%">
                        <col width="8%">
                        <col width="8%">
                        <col width="10%">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>{{ $t('delivery.shipment.reference_no') }}</th>
                          <th>{{ $t('delivery.shipment.tracking_no') }}</th>
                          <th>{{ $t('delivery.shipment.courier_name') }}</th>
                          <th>{{ $t('delivery.shipment.courier_slug') }}</th>
                          <th>{{ $t('delivery.shipment.pickup_note') }}</th>
                          <th>{{ $t('delivery.shipment.signed_by') }}</th>
                          <th>{{ $t('delivery.shipment.lead_time') }}</th>
                          <th>{{ $t('delivery.shipment.status') }}</th>
                          <th>{{ $t('delivery.shipment.updated_at') }}</th>
                          <th>{{ $t('delivery.shipment.operation') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(shipment, index) in shipments" :key="index">
                          <td>{{ index+1 }}</td>
                          <td>{{ shipment.reference_no }}</td>
                          <td>{{ shipment.tracking_no }}</td>
                          <td>{{ shipment.courier_name }}</td>
                          <td>{{ shipment.aftership_courier_slug }}</td>
                          <td>{{ shipment.pickup_note }}</td>
                          <td>{{ shipment.signed_by }}</td>
                          <td>{{ shipment.platform_lead_time }}</td>
                          <td v-html="shipment.status_label"></td>
                          <td>{{ shipment.updated_at }}</td>
                          <td>
                            <a :href="'https://www.lme.com.hk/tracking-center?tracking_no='+shipment.tracking_no" class="btn btn-sm btn-success" target="_blank" title="Tracking Status">
                              <i class="fa fa-external-link" aria-hidden="true"></i>
                            </a>
                            <b-dropdown v-if="shipment.status !== 50 && shipment.status >=10" class="ml-1 mr-1" size="sm">
                              <b-button variant="success" class="dropdown-item" @click="handleUpdateStatus(shipment.id, shipment.tracking_no, 'delivered')"><i class="fa fa-calendar-check-o mr-1"></i>&nbsp; Mark as delivered</b-button>
                              <b-button variant="success" class="dropdown-item" @click="handleUpdateStatus(shipment.id, shipment.tracking_no, 'returned_to_sender')"><i class="fa fa-arrow-circle-left mr-1"></i>&nbsp; Mark as returned to sender</b-button>
                              <b-button variant="success" class="dropdown-item" @click="handleUpdateStatus(shipment.id, shipment.tracking_no, 'lost')"><i class="fa fa-exclamation-triangle mr-1"></i>&nbsp; Mark as lost</b-button>
                              <b-button variant="success" class="dropdown-item" @click="handleUpdateStatus(shipment.id, shipment.tracking_no, 'canceled')"><i class="fa fa-exclamation-triangle mr-1"></i>&nbsp; Mark as canceled</b-button>
                            </b-dropdown>
                            <CButton size="sm" color="warning" @click.stop.prevent="handleShowNoteModal(shipment.id)" class="ml-1"><i class="fa fa-sticky-note-o"></i></CButton>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row">
                        <div class="col-sm-12 col-md-5">
                          <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                          <nav>
                            <b-pagination align="end" :total-rows="this.meta.total" :per-page="this.meta.per_page" v-model="currentPage" :prev-text="$t('general.list.prev')" :next-text="$t('general.list.next')" @change='changePage' hide-goto-end-buttons/>
                          </nav>
                        </div>
                      </div>
                  </div>
                </div><!--col-->
            </div><!--row-->
        </div><!--card-body-->
    </div><!--card-->
    <CModal
      v-if="currentShipmentId"
      title="Shipment Note List"
      :show.sync="showNoteModal"
      color="primary"
      size="xl"
    >
      <note-list  noteableType="delivery_shipments" :noteableId="currentShipmentId"></note-list>
    </CModal>
    <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>

<script>
import LoadingPanel from '@/components/LoadingPanel'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import FileSaver from 'file-saver'
import NoteList from '@/components/NoteList.vue'

export default {
  name: 'Shippers',
  components: {
    LoadingPanel,
    datepicker,
    NoteList
  },
  mounted () {
    this.axios.get('/aftership-courier').then(response => {
      if(response.data && response.data.length > 0){
        const couriers = this.courierOptions = response.data.map((item) => {
          return { value: item.id, text: item.slug}
        })
        var nullOption = [{ value: null, text: this.$t('general.input.please_select_courier') }];
        this.courierOptions = nullOption.concat(couriers);
      }
    }).catch(error => {
      console.log(error)
    })
    this.fetchShipments();
  },
  data () {
    return {
      showNoteModal: false,
      currentShipmentId: undefined,
      shipments: [],
      showLoadingPanel: false,
      meta: [],
      filter: {
        uploadDateFrom: '',
        uploadDateTo: '',
        referenceNo: '',
        trackingNo: '',
        courierId: null,
        status: null,
      },
      courierOptions: [],
      statusOptions: [
        { value: null, text: this.$t('general.input.please_select_status') },
        { value: "requested", text: 'Requested' },
        { value: "info_received", text: 'Info Received' },
        { value: "in_transit", text: 'In Transit' },
        { value: "delivered", text: 'Delivered' },
        { value: "expired", text: 'Expired' },
        { value: "pending", text: 'Pending' },
        { value: "exception", text: 'Exception' },
        { value: "other", text: 'Other' }
      ],
      currentPage: 1,
      show: true
    }
  },
  methods: {
    fetchShipments () {
      this.axios.get('/delivery/shipment').then(response => {
        this.shipments = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    onReset () {
      // evt.preventDefault()
      this.filter.referenceNo = ''
      this.filter.courierId = null
      this.filter.trackingNo = ''
      this.filter.uploadDateFrom = moment().format('YYYY-MM-DD')
      this.filter.uploadDateTo = moment().add(1, 'day').format('YYYY-MM-DD')
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onSearchForm () {
      this.axios.get('/delivery/shipment', {
        params: {
          reference_no: this.filter.referenceNo,
          tracking_no: this.filter.trackingNo,
          courier_id: this.filter.courierId,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo,
          status: this.filter.status,
        }
      }).then(response => {
        this.shipments = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    changePage (pageNum) {
      this.axios.get('/delivery/shipment', {
        params: {
          reference_no: this.filter.referenceNo,
          courier_id: this.filter.courierId,
          tracking_no: this.filter.trackingNo,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo,
          status: this.filter.status,
          page: pageNum
        }
      }).then(response => {
        this.shipments = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    async downloadFilterShipments () {
      this.axios.get('/delivery/shipment/download/', {
        params: {
          courier_id: this.filter.courierId,
          reference_no: this.filter.referenceNo,
          tracking_no: this.filter.trackingNo,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo,
          status: this.filter.status,
        },
        responseType: 'blob'
      }).then((response) => {
        FileSaver.saveAs(response, moment().format('YYYY-MM-DD') + '-shipment.xlsx')
      })
    },
    async downloadNotDeliveriedShipments () {
      this.axios.get('/delivery/shipment/download', {
        params: {
          status: "delivered",
        },
        responseType: 'blob'
      }).then((response) => {
        FileSaver.saveAs(response, moment().format('YYYY-MM-DD') + '-shipment.xlsx')
      })
    },
    handleShowNoteModal: async function ( value) {
      this.currentShipmentId = value
      await this.$nextTick()
      // console.log(this.$el.textContent) // => '已更新'
      this.showNoteModal = true
    },
    handleDelete (shiperId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button'),
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/delivery/shipment/' + shiperId).then(() => {
            this.$router.push('/shipment')
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    },
    handleUpdateStatus(shipmentId, trackingNo, reason) {
      this.$swal({
        title: 'Are you sure',
        text: 'Want to update shipment '+trackingNo+' status?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Yes, mark as "+reason,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.post('/delivery/shipment/update-status/' + shipmentId, {
            "reason": reason,
          }).then((response) => {
            this.showLoadingPanel = false
            if(response.status === "success"){
              this.onSearchForm();
            }
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
